import { AddPackModal } from './AddPackModal';

export default AddPackModal;
